import { useState, useEffect, useContext } from "react";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { Button, Card, Container, Typography, Box } from "@mui/material";

const CARD_SYMBOLS = ["🍎", "🍌", "🍇", "🍊", "🍒", "🥑", "🍉", "🍍"];

export default function MemoryGame() {
  const [cards, setCards] = useState([]);
  const [flipped, setFlipped] = useState([]);
  const [solved, setSolved] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [moves, setMoves] = useState(0);
  const { userData } = useContext(UserDataContext);

  const initGame = () => {
    const duplicatedCards = [...CARD_SYMBOLS, ...CARD_SYMBOLS];
    const shuffledCards = duplicatedCards
      .map((symbol, index) => ({ id: index, symbol }))
      .sort(() => Math.random() - 0.5);

    setCards(shuffledCards);
    setFlipped([]);
    setSolved([]);
    setMoves(0);
    setDisabled(false);
  };

  useEffect(() => {
    initGame();
  }, []);

  const handleClick = (id) => {
    if (disabled || flipped.includes(id) || solved.includes(id)) return;

    const newFlipped = [...flipped, id];
    setFlipped(newFlipped);

    if (newFlipped.length === 2) {
      setMoves((prev) => prev + 1);
      setDisabled(true);
      checkForMatch(newFlipped);
    }
  };

  const checkForMatch = (currentFlipped) => {
    const [firstId, secondId] = currentFlipped;
    const firstCard = cards.find((c) => c.id === firstId);
    const secondCard = cards.find((c) => c.id === secondId);

    if (firstCard.symbol === secondCard.symbol) {
      // Opcjonalne małe opóźnienie, aby gracz zdążył zobaczyć dopasowanie przed zniknięciem
      setTimeout(() => {
        setSolved((prev) => [...prev, firstId, secondId]);
        resetTurn();
      }, 400);
    } else {
      setTimeout(() => {
        resetTurn();
      }, 1000);
    }
  };

  const resetTurn = () => {
    setFlipped([]);
    setDisabled(false);
  };

  const isWon = solved.length === cards.length && cards.length > 0;

  return (
    <div>
      <VN userData={userData} />
      <Container sx={{ py: 5 }}>
        <Card
          elevation={1}
          sx={{
            backgroundColor: "#F8FAFC",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#FFFFFF",
              textAlign: "center",
              pt: 4,
              pb: 2,
              px: 3,
            }}
          >
            <h1>Test Pamięci</h1>
            <Typography
              variant="h5"
              component="h2"
              sx={{ fontWeight: "bold", color: "text.primary", mb: 1 }}
            >
              Ruchy: {moves}
            </Typography>

            {isWon && (
              <div style={styles.winMessage}>
                <h2>Gratulacje! Wygrałeś w {moves} ruchach!</h2>
                <Button size="large" onClick={initGame}>
                  Graj ponownie
                </Button>
              </div>
            )}

            <div style={styles.grid}>
              {cards.map((card) => {
                const isSolved = solved.includes(card.id);
                const isFlipped = flipped.includes(card.id);

                return (
                  <div
                    key={card.id}
                    onClick={() => handleClick(card.id)}
                    style={{
                      ...styles.card,
                      backgroundColor: isFlipped ? "#fff" : "#4CAF50",
                      border: isFlipped
                        ? "2px solid #4CAF50"
                        : "2px solid #ccc",
                      // Wygaszenie i pozostawienie pustego miejsca po odgadnięciu:
                      visibility: isSolved ? "hidden" : "visible",
                      pointerEvents: isSolved ? "none" : "auto",
                    }}
                  >
                    {isFlipped || isSolved ? card.symbol : "?"}
                  </div>
                );
              })}
            </div>

            {!isWon && (
              <Button size="large" onClick={initGame}>
                Resetuj grę
              </Button>
            )}
          </Box>
        </Card>
      </Container>
    </div>
  );
}
const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 80px)",
    gap: "10px",
    margin: "20px auto",
    justifyContent: "center",
  },
  card: {
    width: "80px",
    height: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "32px",
    cursor: "pointer",
    borderRadius: "8px",
    userSelect: "none",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    transition: "transform 0.2s, opacity 0.3s",
  },
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    backgroundColor: "#008CBA",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  winMessage: {
    textAlign: "center",
    marginBottom: "20px",
    color: "#4CAF50",
  },
};
